<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <v-container fluid>
        <v-card rounded>
          <PageBar :title="title" :back="true"/>
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <div class="subtitle-2">Заполните форму и нажмите на кнопку "Создать"</div>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <v-text-field
                    label="Тема запроса"
                    outlined
                    hide-details
                    dense
                    type="text"
                    v-model="form.name"
                ></v-text-field>
              </v-col>
              <v-col md="6" sm="12" cols="12">
                <v-select
                    :items="type"
                    outlined
                    hide-details
                    dense
                    label="Тип запроса"
                    :loading="loading"
                    :disabled="loading"
                    v-model="form.type"
                    no-data-text="Типы для Вашего аккаунта не установлены"
                ></v-select>
              </v-col>
              <v-col md="6" sm="12" cols="12">
                <v-select
                    :items="priority"
                    outlined
                    hide-details
                    dense
                    label="Приоритет"
                    :loading="loading"
                    :disabled="loading"
                    v-model="form.priority"
                    no-data-text="Приоритеты для Вашего аккаунта не установлены"
                ></v-select>
              </v-col>
              <v-col md="6" sm="12" cols="12">
                <v-select
                    :items="departments"
                    outlined
                    hide-details
                    dense
                    label="Отдел"
                    :loading="loading"
                    :disabled="loading"
                    v-model="form.department"
                    no-data-text="Отделы для Вашего аккаунта не установлены"
                ></v-select>
              </v-col>
              <v-col md="6" sm="12" cols="12">
                <v-select
                    :items="product"
                    outlined
                    hide-details
                    dense
                    label="Продукт"
                    :loading="loading"
                    :disabled="loading"
                    v-model="form.product"
                    no-data-text="Продукты для Вашего аккаунта не установлены"
                ></v-select>
              </v-col>
              <v-col md="12" cols="12">
                <v-textarea
                    label="Сообщение"
                    dense
                    auto-grow
                    outlined
                    hide-details
                    rows="12"
                    v-model="form.message"
                ></v-textarea>
              </v-col>
              <v-col md="12" cols="12">
                <input
                    ref="uploader"
                    class="d-none"
                    type="file"
                    multiple
                    @change="onUploadChanged"
                >
                <v-btn
                    depressed
                    small
                    @click="onUploadClick"
                >
                  <v-icon left>mdi-plus</v-icon> Добавить вложения
                </v-btn>
              </v-col>
              <v-col md="12" cols="12" class="pb-0 pt-0">
                <Attachments :list="files.items" :disabled="sending" @remove-emit="delUpload"/>
              </v-col>
            </v-row>
          </v-container>
          <v-divider/>
          <v-container fluid class="text-right">
            <v-btn color="primary" :disabled="loading" :loading="sending" @click="createTicket">
              Создать
            </v-btn>
          </v-container>
        </v-card>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'CreateTicket',
  components: {
    PageBar:      ()  => import('@/components/bar/Page.vue'),
    Attachments:  ()  => import('@/components/list/Attachments'),
  },
  data: () => ({
    title: "Новый запрос",
    loading: true,
    type: [],
    priority: [],
    product: [],
    departments: [],
    form: {
      name: '',
      type: 0,
      product: 0,
      priority: 0,
      department: 0,
      message: ''
    },
    sending: false,
    files: {
      isSelecting: false,
      items: []
    },
  }),
  methods: {
    delUpload: function (index) {
      this.files.items.splice(index, 1);
    },
    onUploadClick() {
      window.console.log('click')
      this.files.isSelecting = true;
      window.addEventListener('focus', () => {
        this.files.isSelecting = false
      }, {once: true});
      this.$refs.uploader.click()
    },
    onUploadChanged(e) {
      for (let i=0; i < e.target.files.length; i++) {
        this.files.items.push({
          name: e.target.files[i].name,
          size: e.target.files[i].size,
          sizeMb: this.bytesToSize(e.target.files[i].size, " "),
          blob: e.target.files[i]
        });
      }
      window.console.log(e.target.files[0]);
    },
    bytesToSize(bytes, seperator = "") {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return `${bytes}${seperator}${sizes[i]}`;
      return `${(bytes / (1024 ** i)).toFixed(1)}${seperator}${sizes[i]}`
    },
    createTicket() {
      this.sending = true;
      let bodyFormData = new FormData();
      bodyFormData.append('name', this.form.name);
      bodyFormData.append('type', this.form.type);
      bodyFormData.append('product', this.form.product);
      bodyFormData.append('priority', this.form.priority);
      bodyFormData.append('message', this.form.message);
      bodyFormData.append('department', this.form.department);
      if (this.files.items.length) {
        for (let i = 0; i < this.files.items.length; i++) {
          bodyFormData.append('documents', this.files.items[i].blob);
        }
      }
      this.$http.post(`${this.$serverApiLink}ticket/create`, bodyFormData, {headers: {'Content-Type': 'multipart/form-data' }}).then(
          response => {
            window.console.log(response.data.data);
            this.sending = false;
            this.$store.commit('setSnack', {
              status: true,
              code: 200,
              message: response.data.message,
              type: 'success'
            });
            this.$router.push({ name: 'ticket', params: {id: response.data.data}});
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.sending = false;
          }
      );
    },
    getRequestConfigs() {
      this.loading = true;
      this.$http.get(`${this.$serverApiLink}config/tickets`).then(
          response => {
            this.createConfigArray(response.data.data);
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loading = false;
          }
      );
    },
    createConfigArray(array) {
      if (array.types) {
        for (let i = 0; i < array.types.length; i++) {
          this.type.push({text: array.types[i].name, value: array.types[i].ID})
        }
      }
      if (array.priorities) {
        for (let i = 0; i < array.priorities.length; i++) {
          this.priority.push({text: array.priorities[i].name, value: array.priorities[i].ID})
        }
      }
      if (array.products) {
        for (let i = 0; i < array.products.length; i++) {
          this.product.push({text: array.products[i].name, value: array.products[i].id})
        }
      }
      if (array.departments) {
        for (let i = 0; i < array.departments.length; i++) {
          this.departments.push({text: array.departments[i].name, value: array.departments[i].ID})
        }
      }
      this.loading = false;
    }
  },
  mounted() {
    this.getRequestConfigs();
  }
}
</script>